module.exports = __webpack_public_path__ + "img/productions_21.cd5053a9.png";